/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Outlet } from "react-router-dom";
import { theme } from "@nordcloud/gnui";
import { useScrollToTop } from "./hooks";
import { ApplicationGrid, ApplicationWrapper, Footer, Header, MenuBar } from "./layout";

export function App() {
  useScrollToTop();

  return (
    <div
      css={{
        marginRight: "auto",
        marginLeft: "auto",
        maxWidth: "100%",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: theme.spacing.spacing04,
        width: "calc(100% - 1rem)",
        height: "100%",
      }}
    >
      <ApplicationGrid>
        <Header />
        <MenuBar />
        <ApplicationWrapper>
          <Outlet />
        </ApplicationWrapper>
        <Footer />
      </ApplicationGrid>
    </div>
  );
}
